import {
  DATE_RANGE_LABELS,
  setDateRange,
  useDateRange,
} from "@app/lib/date-range";
import type { DateRange } from "@app/lib/date-range";
import { useRouter } from "@tanstack/react-router";

const OPTIONS: DateRange[] = ["1Y", "2Y", "5Y", "ALL"];

// The global lookback window, applied across every view. Writes localStorage
// and invalidates the router so route loaders refetch with the new window.
export default function DateRangeSwitcher() {
  const router = useRouter();
  const current = useDateRange();

  const select = (value: DateRange) => {
    if (value === current) return;
    setDateRange(value);
    router.invalidate();
  };

  return (
    <div
      className="flex items-center rounded border border-gray-300 overflow-hidden text-xs"
      title="Date range — applied to every view"
    >
      {OPTIONS.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => select(option)}
          className={`px-2 py-1 ${
            option === current
              ? "bg-gray-900 text-white"
              : "bg-white text-gray-600 hover:bg-gray-50"
          }`}
        >
          {DATE_RANGE_LABELS[option]}
        </button>
      ))}
    </div>
  );
}
